/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit WorkHours/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconUpdate from 'DesignSystem/Svgs/TysiaIconUpdate/index'



/** @type {import('Simple/types.js').View} */
export default function WorkHours({
  children,
  viewPath = "/App/Account/Topbar/Tabs/More/Content/Tabs/Tab/Icon/WorkHours",
  hovered,
  selected
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsGreen600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.600'
        })
  return (<React.Fragment
>
<TysiaIconUpdate
  viewPath={`${viewPath}/TysiaIconUpdate`}
 width={16}
 height={16}
 fill={hovered && selected ? dtColorsGreen600 : hovered ? dtColorsWhite : selected ? dtColorsGreen600 : dtColorsWhite}
/>
{children}
</React.Fragment>)
}